import {
  AdminAnalyticsRequest,
  AdminAnalyticsResponse,
} from "../../interfaces/analytics";

//#region Get Admin Analytics

export const GET_ADMIN_ANALYTICS = "GET_ADMIN_ANALYTICS";
export const GET_ADMIN_ANALYTICS_SUCCESS: any = "GET_ADMIN_ANALYTICS_SUCCESS";
export const GET_ADMIN_ANALYTICS_ERROR: any = "GET_ADMIN_ANALYTICS_ERROR";

export interface GetAdminAnalyticsAction {
  type: typeof GET_ADMIN_ANALYTICS;
  payload: {
    query: AdminAnalyticsRequest;
  };
}

export interface GetAdminAnalyticsSuccessAction {
  type: typeof GET_ADMIN_ANALYTICS_SUCCESS;
  payload: AdminAnalyticsResponse;
}

export interface GetAdminAnalyticsErrorAction {
  type: typeof GET_ADMIN_ANALYTICS_ERROR;
  payload: any;
}
//#endregion

//#region Get Admin Analytics V2

export const GET_ADMIN_ANALYTICS_V2 = "GET_ADMIN_ANALYTICS_V2";
export const GET_ADMIN_ANALYTICS_V2_SUCCESS: any =
  "GET_ADMIN_ANALYTICS_V2_SUCCESS";
export const GET_ADMIN_ANALYTICS_V2_ERROR: any = "GET_ADMIN_ANALYTICS_V2_ERROR";

export interface GetAdminAnalyticsV2Action {
  type: typeof GET_ADMIN_ANALYTICS_V2;
  payload: {
    query: AdminAnalyticsRequest;
  };
}

export interface GetAdminAnalyticsV2SuccessAction {
  type: typeof GET_ADMIN_ANALYTICS_V2_SUCCESS;
  payload: AdminAnalyticsResponse;
}

export interface GetAdminAnalyticsV2ErrorAction {
  type: typeof GET_ADMIN_ANALYTICS_V2_ERROR;
  payload: any;
}
//#endregion

// Export a union type that represents all possible actions
export type ActionTypes =
  | GetAdminAnalyticsAction
  | GetAdminAnalyticsSuccessAction
  | GetAdminAnalyticsErrorAction
  | GetAdminAnalyticsV2Action
  | GetAdminAnalyticsV2SuccessAction
  | GetAdminAnalyticsV2ErrorAction;
